import Rellax from 'rellax';
import Base from '../../_config/base';

// Initialize Rellax
// eslint-disable-next-line no-unused-vars
const rellax = new Rellax('.rellax');

class Intro extends Base {
  // eslint-disable-next-line no-useless-constructor
  constructor(el) {
    super(el);

    const isBlockHide = (block) => {
      const newValue = window.pageYOffset + window.innerHeight - 60;
      const eleValue = block.offsetTop;

      if (newValue < eleValue) {
        // above element
        block.classList.add('scrollAnim');
      } else if (newValue > eleValue) {
        // below element
        block.classList.remove('scrollAnim');
        if (block.classList.contains('cards')) {
          const textCards = block.querySelectorAll('.card__item_text');
          if (textCards.length) {
            textCards.forEach((card) => card.classList.add('animCard'));
          }
        }
      }
    };

    window.addEventListener('scroll', () => {
      isBlockHide(el);
    });
  }
}

Intro.className = 'Intro';
export default Intro;
